import { render, staticRenderFns } from "./smAboutMe.vue?vue&type=template&id=90889d4a&"
import script from "./smAboutMe.vue?vue&type=script&lang=js&"
export * from "./smAboutMe.vue?vue&type=script&lang=js&"
import style0 from "./smAboutMe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports